import { Loader2 } from 'lucide-react';

function getCompletionStyle(completedResult) {
  if (completedResult.disconnected) {
    return {
      border: 'border-blue-800',
      bg: 'bg-blue-900/20',
      iconBg: 'bg-blue-500/20',
      iconText: 'text-blue-400',
      icon: null,
      spinner: true,
      label: 'Traitement en cours en arrière-plan',
      buttonBg: 'bg-blue-600 hover:bg-blue-700',
    };
  }

  if (completedResult.documents_created > 0) {
    return {
      border: 'border-green-800',
      bg: 'bg-green-900/20',
      iconBg: 'bg-green-500/20',
      iconText: 'text-green-400',
      icon: '\u2713',
      label: 'Crawl terminé avec succès',
      buttonBg: 'bg-green-600 hover:bg-green-700',
    };
  }

  if (completedResult.pages_crawled > 0) {
    return {
      border: 'border-yellow-800',
      bg: 'bg-yellow-900/20',
      iconBg: 'bg-yellow-500/20',
      iconText: 'text-yellow-400',
      icon: '!',
      label: 'Toutes les pages sont des doublons',
      buttonBg: 'bg-yellow-600 hover:bg-yellow-700',
    };
  }

  return {
    border: 'border-red-800',
    bg: 'bg-red-900/20',
    iconBg: 'bg-red-500/20',
    iconText: 'text-red-400',
    icon: '\u2717',
    label: 'Aucune page indexée',
    buttonBg: 'bg-red-600 hover:bg-red-700',
  };
}

function CompletionIcon({ style }) {
  if (style.spinner) {
    return <Loader2 className={`h-5 w-5 animate-spin ${style.iconText}`} />;
  }
  return (
    <div className={`flex h-6 w-6 items-center justify-center rounded-full ${style.iconBg} text-sm font-semibold ${style.iconText}`}>
      {style.icon}
    </div>
  );
}

function CompletionStats({ completedResult }) {
  if (completedResult.disconnected) return null;
  return (
    <div className="grid grid-cols-3 gap-3 text-center">
      <div className="rounded bg-zinc-900/50 p-2">
        <div className="text-2xl font-bold text-white">{completedResult.pages_crawled}</div>
        <div className="text-xs text-zinc-400">Pages crawlées</div>
      </div>
      <div className="rounded bg-zinc-900/50 p-2">
        <div className="text-2xl font-bold text-green-400">{completedResult.documents_created ?? completedResult.chunks_created ?? 0}</div>
        <div className="text-xs text-zinc-400">Indexées</div>
      </div>
      <div className="rounded bg-zinc-900/50 p-2">
        <div className="text-2xl font-bold text-blue-400">{completedResult.images_analyzed || 0}</div>
        <div className="text-xs text-zinc-400">Images analysées</div>
      </div>
    </div>
  );
}

export function CrawlCompletionPanel({ completedResult, onClose }) {
  if (!completedResult) return null;

  const style = getCompletionStyle(completedResult);

  return (
    <div data-testid="crawl-complete-panel" className={`space-y-3 rounded-sm border ${style.border} ${style.bg} p-4`}>
      <div className="flex items-center gap-3">
        <CompletionIcon style={style} />
        <p className={`text-sm font-medium ${style.iconText}`}>{style.label}</p>
      </div>

      {completedResult.message ? (
        <p data-testid="crawl-complete-message" className="text-xs text-zinc-400">{completedResult.message}</p>
      ) : null}

      <CompletionStats completedResult={completedResult} />

      <button
        type="button"
        data-testid="crawl-complete-close-button"
        onClick={onClose}
        className={`h-10 w-full rounded-sm ${style.buttonBg} font-medium text-white transition-colors`}
      >
        Fermer
      </button>
    </div>
  );
}
